// extracted by mini-css-extract-plugin
export default {"container":"SectionGastosProdutivos_container__tUkqJ","cabecalho":"SectionGastosProdutivos_cabecalho__T3P8l"};